import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, Facebook, Instagram, Linkedin } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';

const Footer = () => {
  const { t, language, isRTL } = useLanguage();

  return (
    <footer className="bg-neutral-900 text-gray-300" dir={isRTL ? 'rtl' : 'ltr'}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div>
            <img 
              src="https://i.pinimg.com/736x/79/a8/ea/79a8eaa5d1894ac349ce34b60e60b949.jpg" 
              alt="EliteMeat Farm" 
              className="h-14 w-auto mb-4"
            />
            <p className="text-sm text-gray-400 leading-relaxed">
              {t('footerAbout')}
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white font-semibold mb-4">{t('quickLinks')}</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/about" className="text-sm hover:text-red-500 transition-colors">
                  {t('aboutUs')}
                </Link>
              </li>
              <li>
                <Link to="/farms" className="text-sm hover:text-red-500 transition-colors">
                  {t('ourFarms')}
                </Link>
              </li>
              <li>
                <Link to="/products" className="text-sm hover:text-red-500 transition-colors">
                  {t('products')}
                </Link>
              </li>
              <li>
                <Link to="/quality" className="text-sm hover:text-red-500 transition-colors">
                  {t('qualitySafety')}
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-white font-semibold mb-4">{t('contactInfo')}</h3>
            <ul className="space-y-3">
              <li className="flex items-start gap-2">
                <Phone size={18} className="mt-0.5 flex-shrink-0 text-red-500" />
                <a href="tel:01270706065" className="text-sm hover:text-red-500 transition-colors">
                  01270706065
                </a>
              </li>
              <li className="flex items-start gap-2">
                <Mail size={18} className="mt-0.5 flex-shrink-0 text-red-500" />
                <a href="mailto:elitemeat@gmail.com" className="text-sm hover:text-red-500 transition-colors break-all">
                  elitemeat@gmail.com
                </a>
              </li>
              <li className="flex items-start gap-2">
                <MapPin size={18} className="mt-0.5 flex-shrink-0 text-red-500" />
                <span className="text-sm">
                  {language === 'ar' 
                    ? '821 خط 4 مزارع العرابي الزراعية الشمالية'
                    : '821 Line 4 North Orabi Agricultural Farms'}
                </span>
              </li>
            </ul>
          </div>

          {/* Social & Newsletter */}
          <div>
            <h3 className="text-white font-semibold mb-4">
              {language === 'ar' ? 'تابعنا' : 'Follow Us'}
            </h3>
            <div className="flex gap-3 mb-6">
              <a href="https://www.facebook.com/profile.php?id=61572273943626" target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-full bg-gray-800 flex items-center justify-center hover:bg-red-600 transition-colors">
                <Facebook size={20} />
              </a>
              <a href="https://www.instagram.com/elitemeatfarms/" target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-full bg-gray-800 flex items-center justify-center hover:bg-red-600 transition-colors">
                <Instagram size={20} />
              </a>
              <a href="#" className="w-10 h-10 rounded-full bg-gray-800 flex items-center justify-center hover:bg-red-600 transition-colors">
                <Linkedin size={20} />
              </a>
            </div>
            <p className="text-sm text-gray-400">
              {language === 'ar' 
                ? 'تابع آخر منتجاتنا وعروضنا.'
                : 'Stay updated with our latest products and offers.'}
            </p>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-8 pt-8 text-center">
          <p className="text-sm text-gray-400">
            © {new Date().getFullYear()} EliteMeat Farm. {t('allRightsReserved')}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
